import React from "react";
import { AlertTriangle, RefreshCw, Home, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // Log error to console in development
    if (process.env.NODE_ENV === "development") {
      console.error("Error caught by boundary:", error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-container">
            <div className="error-boundary-content">
              <div className="error-icon">
                <AlertTriangle size={64} />
              </div>

              <h1 className="error-title">Something went wrong</h1>
              <p className="error-description">
                We're sorry, but something unexpected happened. Our team has
                been notified and is working to fix the issue.
              </p>

              <div className="error-actions">
                <button onClick={this.handleReload} className="btn btn-primary">
                  <RefreshCw size={18} />
                  Reload Page
                </button>
                <Link to="/" className="btn btn-secondary">
                  <Home size={18} />
                  Go Home
                </Link>
              </div>

              <div className="error-help">
                <p>If the problem persists, please contact our support team.</p>
                <Link to="/contact" className="contact-link">
                  <Mail size={16} />
                  Contact Support
                </Link>
              </div>

              {process.env.NODE_ENV === "development" && this.state.error && (
                <details className="error-details">
                  <summary>Error Details (Development Only)</summary>
                  <div className="error-stack">
                    <h4>Error:</h4>
                    <pre>{this.state.error.toString()}</pre>
                    <h4>Stack Trace:</h4>
                    <pre>{this.state.errorInfo.componentStack}</pre>
                  </div>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
